import { Text } from '@mantine/core'
import { CAPTION_LS, DATA_FZ, TILE_TEXT } from './railStyle'

// The unit word trailing a reading in a daily Weather row — "AIR" in
// "85° / 80° AIR", "RAIN" in "34% RAIN", the compass point on the seas row.
//
// Set exactly like the time in a Tides/Sun/Moon row: DATA_FZ.value, regular
// weight, plain white. So a daily row uses ONE size and ONE color throughout,
// and weight alone separates the reading from the word naming it — the same
// contrast ArrowLabel/time already draws next door ("High" bold, "3:41 AM"
// regular). No small size, no gray, no uppercase, no tracking: each of those
// was a further axis of difference, and together they made these rows read as
// a different kind of object from the bands above and below.
//
// Lowercased in CSS rather than with toLowerCase(), so the DOM keeps the
// catalog's own capitalisation for screen readers and copy/paste. Compass
// points opt out via `preserveCase` — "SE" is an abbreviation, and "se" reads
// as a word rather than a bearing.
export function RowUnit({ children, preserveCase = false }) {
  return (
    <Text
      fz={DATA_FZ.value}
      fw={400}
      tt={preserveCase ? undefined : 'lowercase'}
      style={{ color: TILE_TEXT.primary, whiteSpace: 'nowrap' }}
    >
      {children}
    </Text>
  )
}

// The compact version, for the hourly rows behind the disclosure. Those pack
// six readings onto one line, so they keep the small dimmed caption — at
// RowUnit's size the hour rows would not fit. This is deliberately NOT the
// daily treatment; the two are different densities doing different jobs.
export default function Caption({ children }) {
  return (
    <Text
      fz={DATA_FZ.label}
      tt="uppercase"
      style={{ letterSpacing: CAPTION_LS, color: TILE_TEXT.faint, whiteSpace: 'nowrap' }}
    >
      {children}
    </Text>
  )
}
